"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = void 0;
exports.actionCreators = {
    requestRobotScript: function (requestedScriptId) { return function (dispatch, getState) {
        var appState = getState();
        if (appState && appState.robotScript && appState.clientList && appState.clientList.connectedClient) {
            var requestBody = JSON.stringify({
                sessionGuid: "" + appState.clientList.connectedClient.sessionGuid,
                scriptId: requestedScriptId
            });
            fetch("/api/robotscript", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: requestBody
            })
                .then(function (response) {
                if (!response.ok)
                    response.text().then(function (responseText) {
                        dispatch({ type: 'RECEIVED_ERROR_ROBOT_SCRIPT', errorMessage: responseText + " (" + response.status + ")" });
                    });
                else {
                    dispatch({ type: 'FINISHED_ROBOT_SCRIPT' });
                }
                ;
            })
                .catch(function (error) { return dispatch({ type: 'RECEIVED_ERROR_ROBOT_SCRIPT', errorMessage: error }); });
            dispatch({ type: 'REQUEST_ROBOT_SCRIPT', scriptId: requestedScriptId });
        }
    }; }
};
var unloadedState = { isRequestingScript: false, scriptRequestError: '', requestedScriptId: undefined };
exports.reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_ROBOT_SCRIPT':
            return {
                isRequestingScript: true,
                scriptRequestError: state.scriptRequestError,
                requestedScriptId: action.scriptId
            };
        case 'FINISHED_ROBOT_SCRIPT':
            return {
                isRequestingScript: false,
                scriptRequestError: '',
                requestedScriptId: state.requestedScriptId
            };
        case 'RECEIVED_ERROR_ROBOT_SCRIPT':
            return {
                isRequestingScript: false,
                scriptRequestError: action.errorMessage,
                requestedScriptId: state.requestedScriptId
            };
        default:
            return state;
    }
};
//# sourceMappingURL=RobotScript.js.map